import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { AuthLazyGuard } from '@app/guards/auth/auth-lazy.guard';
import { ClientComponent } from '@app/modules/client/client.component';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) },
  {
    path: 'service',
    component: ClientComponent,
    canLoad: [AuthLazyGuard],
    loadChildren: () => import('./modules/client/client.module').then(m => m.ClientModule),
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
